







































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import moment from "moment";
import helpers from "@/helpers/helper";
import BTableConfig from "../../core/BTableConfig/BTableConfig";
import Transaccion from '@/models/tarjeta/transaccion.model';
@Component
export default class MovimientoTarjetaTable extends GenericBTable<
  Transaccion
> {
  @Prop() readonly title!: string;
  @Prop() readonly tarjetaId!: number;
  @Prop() readonly hideFilters!: boolean;
  @Prop() readonly checkable!: boolean;
  fechaDesde: Date | null = null;
  fechaHasta: Date | null = null;
  sync: boolean = false;

  constructor() {
    super();
    this.fechaDesde = null;
    this.fechaHasta = null;
  }
  get hayTarjeta() {
    return !!this.tarjetaId;
  }
  created() {
    this.setupTable();
    this.formatColumns();
  }

  setupTable() {
    this.tableConfig.controller = "transaccion";
    this.tableConfig.whereParams = this.queries;
    this.tableConfig.activeActions = false;
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.style.narrowed = true;
    this.tableConfig.detailed = true;
    this.tableConfig.pagination.perPage = 5;
    this.tableConfig.include = "Tarjeta.Banco|Subsidio";
    this.tableConfig.sorting.field = "fechaTransaccion";
    this.tableConfig.customEmptyTemplate = false;
    this.tableConfig.emptyText = "No hay transacciones.";
    this.$emit("update:config", this.tableConfig);
  }
  formatColumns() {
    let monto = new BTableColumn("monto", "Monto", true);
    monto.customTemplate = true;
    let subsidio = new BTableColumn("subsidioNombre", "Subsidio", false);
    subsidio.customTemplate = true;
    let fecha = new BTableColumn("fechaTransaccion", "Fecha");
    fecha.type = BTableColumnType.Date;
    let tarjeta = new BTableColumn("numeroTarjeta", "Número de tarejta");
    tarjeta.customTemplate = true;
    this.tableConfig.insertColumns(monto, subsidio, fecha);
  }
  get queries() {
    let where = String();
    let queries = [];
    queries.push(`tarjetaId=${this.tarjetaId}`);
    if (this.fechaDesde)
      queries.push(`fechaTransaccion >= "${moment(this.fechaDesde).format()}"`);
    if (this.fechaHasta)
      queries.push(`fechaTransaccion <= "${moment(this.fechaHasta).format()}"`);

    where = queries.join("&");
    //  if (this.whereParams) where += this.whereParams;
    return where;
  }
  buscar() {
    this.tableConfig.whereParams = this.queries;
    if (this.tableConfig.reload) this.tableConfig.reload();
  }
  limpiar() {
    this.fechaDesde = null;
    this.fechaHasta = null;
  }
}
